<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Stok Opname - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Stok Opname - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Gudang / Stok Opname / Edit</span
        >
        <span v-else class="font-small">/ Gudang / Stok Opname / Tambah</span>
      </div>
    </div>
    <form-stok-opname :id="id" />
  </div>
</template>

<script>
import FormStokOpname from '@/components/gudang/FormStokOpname'

export default {
  components: {
    FormStokOpname,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
